import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PaymentFieldConfig } from "@evergiving/common/dist/es2015/form";

import { setPaymentDay, setPaymentSourceKind } from "@/lib/redux/actions";
import { RootState } from "@/lib/redux/types";

import { StartDateField } from "@/lib/components/StartDateField";
import { authorizedPaymentSourceSelector } from "@/lib/misc/formLink";
import { getStartDates } from "@/lib/misc/startDateUtil";

import { PaymentDaysField } from "./PaymentDaysField";
import { PaymentMethod } from "./PaymentMethod";

export type PaymentSectionProps = {
  config: PaymentFieldConfig;
  autoFocus?: boolean;
};

export const PaymentSection = ({ config, autoFocus }: PaymentSectionProps) => {
  const paymentFrequency = useSelector(
    (state: RootState) => state.paymentFrequency
  );
  const paymentSourceKind = useSelector(
    (state: RootState) => state.paymentSourceKind
  );
  const paymentDay = useSelector((state: RootState) => state.paymentDay);
  const authorizedPaymentSource = useSelector(
    authorizedPaymentSourceSelector
  );

  const startDates = getStartDates(paymentFrequency, paymentSourceKind);

  const dispatch = useDispatch();

  const handlePaymentMethodChange = useCallback(
    (newValue) => {
      dispatch(setPaymentSourceKind(newValue));
    },
    [dispatch]
  );

  const handleSetPaymentDay = useCallback(
    (day: number) => {
      dispatch(setPaymentDay(day));
    },
    [dispatch]
  );

  return (
    <>
      <PaymentMethod
        autoFocus={autoFocus}
        config={config}
        onPaymentMethodChange={handlePaymentMethodChange}
        paymentSourceKind={paymentSourceKind}
        authorizedPaymentSource={authorizedPaymentSource}
      />

      {startDates.length > 0 && (
        <StartDateField
          labelText={config.startDateText}
          startDates={startDates}
        />
      )}

      {config.paymentDays !== undefined ? (
        <PaymentDaysField
          config={config.paymentDays}
          onSetPaymentDay={handleSetPaymentDay}
          value={paymentDay}
        />
      ) : null}
    </>
  );
};
